export const WINDOW_FORM_DEFAULT_DEFINITIONS = {
  2: { form_id: 2, sections: [], show_built_in: false },
  4: { form_id: 4, sections: [], show_built_in: false },
  5: { form_id: 5, sections: [], show_built_in: false },
  8: { form_id: 8, sections: [], show_built_in: false },
  10: { form_id: 10, sections: [], show_built_in: false },
};
